// src/components/preparer-only/PreparerOnly.tsx
// Route guard: allows Preparer (Windvoice.Preparer) and Super Admin only.
import useSession from '@hooks/useSession';
import NotFound from '@components/not-found/NotFound';

interface PreparerOnlyProps {
    readonly children: React.ReactNode;
}

const PreparerOnly = ({ children }: PreparerOnlyProps) => {
    const { isUser, isSuperAdmin, loading } = useSession();

    if (loading) {
        return <div>Loading...</div>;
    }

    if (!isUser && !isSuperAdmin) {
        return <NotFound />;
    }

    return <>{children}</>;
};

export default PreparerOnly;
